var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm"},[_c('page-header',{attrs:{"title":"Customer Registration","breadcrumb":"Dashboard > CRM"}}),_c('div',{staticClass:"card py-4 px-3"},[_c('div',{staticClass:"mt-4"},[_c('apexchart',{staticClass:"w-full",attrs:{"type":"line","height":"250","options":_vm.chartOptions,"series":_vm.series}})],1)]),_c('customer-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }